konnyScript(function ($) {
    // 1. Swiper 초기화
    var tabNavSlide = new Swiper("#tab_nav_swiper_slide", {
        slidesPerView: 'auto',
        grabCursor: true,
        centeredSlides: true,
        centeredSlidesBounds: true,
        normalizeSlideIndex: true
    });

    // Tab Scroll & Click Logic
    (function () {
        const $tabs = $('.eventWrap .navWrap li');
        const sections = [...Array($tabs.length)].map((_, i) => $('#tabCon' + (i + 1)));
        
        let isFromClick = false;
        let scrollWatcher;

        // 탭 클릭 이벤트
        $('#tab_nav_swiper_slide a').on('click', function (e) {
            e.preventDefault();
            const $li = $(this).closest('li');
            const index = $li.index();

            $li.addClass('on').siblings().removeClass('on');
            tabNavSlide.slideTo(index);

            const headerHeight = $('#header').outerHeight() || 0;
            const navHeight = $('.eventWrap .navWrap').outerHeight() || 0;
            const fixHeight = headerHeight + navHeight;
            const fixedTop = parseInt(getComputedStyle(document.querySelector('.eventWrap .navWrap')).top) || (window.innerWidth <= 749 ? 60 : 68);

            const targetSection = $('#tabCon' + (index + 1));

            if (targetSection.length) {
                // [수정] 이동 위치를 1px 아래로 내리기 위해 +1 추가
                const targetTop = targetSection.offset().top - fixHeight - fixedTop + 1;

                isFromClick = true;
                window.scrollTo({
                    top: targetTop,
                    behavior: 'smooth'
                });

                cancelAnimationFrame(scrollWatcher);
                function watchScroll() {
                    const current = $(window).scrollTop();
                    if (Math.abs(current - targetTop) < 3) {
                        isFromClick = false;
                        $(window).trigger('scroll');
                        return;
                    }
                    scrollWatcher = requestAnimationFrame(watchScroll);
                }
                watchScroll();
            }
        });

        // 윈도우 스크롤 이벤트
        $(window).on('load scroll', function () {
            if (!$('.eventWrap .navWrap').length || isFromClick) return;

            const headerHeight = $('#header').outerHeight() || 0;
            const navHeight = $('.eventWrap .navWrap').outerHeight() || 0;
            const fixHeight = headerHeight + navHeight;
            const winTop = $(window).scrollTop();
            
            const fixedTop = parseInt(getComputedStyle(document.querySelector('.eventWrap .navWrap')).top, 10) || (window.innerWidth <= 749 ? 94 : 68);
            
            // [수정] 고정되는 위치를 1px 올리기(더 빨리 고정) 위해 -1 추가
            const navTop = $('.eventWrap .navArea').offset().top - fixedTop - 1;

            let activeIndex = -1;
            const ACTIVATION_OFFSET = -150;

            for (let i = sections.length - 1; i >= 0; i--) {
                if (winTop > sections[i].offset().top - fixHeight + ACTIVATION_OFFSET) {
                    activeIndex = i;
                    break;
                }
            }

            // 네비게이션 고정 처리
            if (winTop > navTop) {
                $('.eventWrap .navWrap').addClass('fixed');
            } else {
                $('.eventWrap .navWrap').removeClass('fixed');
            }

            // 활성 탭 업데이트 및 Swiper 이동
            if (activeIndex !== -1) {
                const $activeTab = $tabs.eq(activeIndex);
                if (!$activeTab.hasClass('on')) {
                    $activeTab.addClass('on').siblings().removeClass('on');
                    tabNavSlide.slideTo(activeIndex);
                }
            } else {
                $tabs.removeClass('on');
            }
        });
    })();
});